import type { FaireProductEntity } from "../../entity_types/product";

export const p_dryfziu5rz: FaireProductEntity = {
  token: "p_dryfziu5rz",
  type: "product",
  name: "Thank You Sun thank you greeting card",
  brandToken: "b_4cu4uycf",
  brandName: "Red Cap Cards",
  imageUrl:
    "https://cdn.faire.com/fastly/fe8041b12174e673f38593b59ec6feb4073b51b659ddde159773a30780074aca.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fc8c96b0fd08f3fc2f680db4f4ca05b75278c38501e4cf3050fc5d04b8a9ae57.jpeg",
    "https://cdn.faire.com/fastly/7c33ebbfd4b1e816df022e41c2ab84619290053b74c3b6894e816991e6bfc374.jpeg",
  ],
  priceDollars: 2.75,
  description:
    "Blank inside. 100lb heavyweight card stock. Offset printed. 5.5 x 4.25 inches. Illustrated by Daren Thomas Magee. Printed by Red Cap Cards in Los Angeles, California, USA, on recycled paper.\nAvailable as both single cards and pre-packaged boxed cards.\n• Each single card comes with an envelope and a cellophane sleeve.\n• Boxed sets are 8 cards with envelopes and are to be sold as packaged, NOT TO BE re-sold as individual cards.",
  tags: [],
  msrpDollars: 5.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:10.430Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
